
export const SERVICES_PACKAGES_API =  "servicePackages";
export const SERVICES_PACKAGE_ITEMS_API =  "servicePackageItems";
